import React from "react";
import "ckeditor5/ckeditor5.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
    ClassicEditor, Essentials, Paragraph, Heading, Bold, Italic, Underline,
    Strikethrough, Font, Alignment, List, TodoList, Link, BlockQuote,
    Table, TableToolbar, TableProperties, TableCellProperties,
    Image, ImageToolbar, ImageUpload, Base64UploadAdapter, MediaEmbed, SourceEditing,
    GeneralHtmlSupport, Code, CodeBlock, HorizontalLine, PageBreak, SpecialCharacters,
    Subscript, Superscript, RemoveFormat, Indent, Undo, Highlight,
} from "ckeditor5";

interface CustomCKEditorProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    error?: string;
    required?: boolean;
    disabled?: boolean;
}

const CustomCKEditor: React.FC<CustomCKEditorProps> = ({
    value,
    onChange,
    label,
    error,
    required = false,
    disabled = false,
}) => {
    return (
        <div className="w-full">
            {label && (
                <label className="block mb-2 font-medium text-gray-700">
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}

            <CKEditor
                editor={ClassicEditor}
                disabled={disabled}
                config={{
                    licenseKey: "GPL",

                    htmlSupport: {
                        allow: [
                            {
                                name: /.*/,
                                attributes: true,
                                classes: true,
                                styles: true,
                            },
                        ],
                    },

                    plugins: [
                        Essentials, Paragraph, Heading, Bold, Italic, Underline, Strikethrough,
                        Font, Alignment, List, TodoList, Link, BlockQuote, Table, TableToolbar,
                        TableProperties, TableCellProperties, Image, ImageToolbar, ImageUpload,
                        Base64UploadAdapter, MediaEmbed, SourceEditing, GeneralHtmlSupport, Code,
                        CodeBlock, HorizontalLine, PageBreak, SpecialCharacters, Subscript,
                        Superscript, RemoveFormat, Indent, Undo, Highlight,
                    ],

                    toolbar: {
                        items: [
                            "undo", "redo",
                            "|", "heading",
                            "|", "bold", "italic", "underline", "strikethrough",
                            "|", "fontSize", "fontFamily", "fontColor", "fontBackgroundColor",
                            "|", "alignment",
                            "|", "bulletedList", "numberedList", "todoList",
                            // "|", "link", "blockQuote",
                            // "|", "insertTable", "uploadImage", "mediaEmbed",
                            // "|", "sourceEditing", "code", "codeBlock",
                            // "|", "horizontalLine", "pageBreak",
                            // "|", "specialCharacters",
                            // "|", "subscript", "superscript",
                            // "|", "removeFormat",
                            // "|", "outdent", "indent",
                            // "|", "highlight",
                        ],
                        shouldNotGroupWhenFull: true,
                    },
                }}
                data={value}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onChange={(_, editor: any) => {
                    const data = editor.getData();
                    onChange(data);
                }}
            />

            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
        </div>
    );
};

export default CustomCKEditor;
